import { SUBSCRIPTION_PLANS } from '@medflex/utils/subscriptionEnums';
import { useSelector } from 'react-redux';
import { NAME, STATUS } from '../store/models/subscription';

const useSubscription = () => {
  const { status, ...properties } = useSelector(state => state[NAME]);

  const isUserProfileLoading = useSelector(state => state.loading.models.superuser);

  const isBasicUser =
    (properties.trialEndedAt && properties.plan === SUBSCRIPTION_PLANS.PROFESSIONALPLUS) ||
    properties.plan === SUBSCRIPTION_PLANS.BASIC;

  return {
    isBasicUser,
    status: isUserProfileLoading ? STATUS.LOADING : status,
    ...properties,
  };
};

export default useSubscription;
